import Operation_vue_vue_type_script_setup_true_lang_default from "./Operation.vue.script.js";
//#region src/v2/features/operation/Operation.vue
var Operation_default = Operation_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Operation_default as default };

//# sourceMappingURL=Operation.vue.js.map